var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 21.7502L4.25 21.7502C3.14543 21.7502 2.25 20.8547 2.25 19.7502L2.25 8.58351C2.25 7.47894 3.14543 6.58351 4.25 6.58351L15.4167 6.5835C16.5212 6.5835 17.4167 7.47893 17.4167 8.5835L17.4167 19.7502C17.4167 20.8547 16.5212 21.7502 15.4167 21.7502Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58325 6.58333V4.25C6.58325 3.14543 7.47868 2.25 8.58325 2.25H19.7499C20.8545 2.25 21.7499 3.14543 21.7499 4.25V15.4167C21.7499 16.5212 20.8545 17.4167 19.7499 17.4167H17.4166",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy-2.61cdd785862e36d1724ca2fc82435888.svg";
export { ForwardRef as ReactComponent };